module.exports = __webpack_public_path__ + "static/media/liste522f975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/galleryUploadIcons/list.svg
// module id = 1241
// module chunks = 0